import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface SelectorOption {
  id: string;
  iconActive: string;
  iconInactive: string;
  activeClass: string;
}

@Component({
  selector: 'app-generic-selector',
  templateUrl: './generic-selector.component.html',
  styleUrls: ['./custom-source-selector.component.scss'],
})
export class GenericSelectorComponent {
  @Input() selected: string[] = [];
  @Input() options: SelectorOption[] = [];
  @Input() mode: 'single' | 'multiple' = 'multiple';
  @Output() selection = new EventEmitter<string[]>();

  clickNode(nodeId: string) {
    if (this.mode === 'single') {
      this.selection.emit([nodeId]);
      return;
    }
    if (this.selected.includes(nodeId)) {
      this.selection.emit(this.selected.filter((n) => n !== nodeId));
    } else {
      this.selection.emit([...this.selected, nodeId]);
    }
  }

  isSelected(nodeId: string): boolean {
    return this.selected.includes(nodeId);
  }

  getClasses(nodeId: string, activeClass: string): string {
    return this.isSelected(nodeId)
      ? activeClass
      : 'border-1 border-grey-100';
  }
}